module.exports = __webpack_public_path__ + "static/media/googleIcon.48d4a808.svg";